export default __webpack_public_path__ + "static/media/1173.4345f61a.png";